<template>
  <v-btn class="add-to-trip-planner" text @click="tripPlannerToggle">
    <v-icon v-if="inTripPlanner" left :color="buttonData.iconColour">
      {{ buttonData.icon }}
    </v-icon>
    <svg v-else class="trip-planner-icon" xmlns="http://www.w3.org/2000/svg" id="Layer_2" data-name="Layer 2" viewBox="0 0 18.31 18.37"><g id="Layer_1-2" data-name="Layer 1"><g><path d="m1.11,5.26c-.61,0-1.11.5-1.11,1.11v10.88c0,.61.5,1.11,1.11,1.11h16.08c.61,0,1.11-.5,1.11-1.11V6.38c0-.61-.5-1.11-1.11-1.11H1.11Zm14.61,10.52H2.59v-7.94h13.13v7.94Z" style="stroke-width: 0px;"></path><path d="m8.37,3.55c.1-.37.39-1.23.81-1.22.4,0,.66.86.75,1.23.15.62.78,1.01,1.4.85.38-.09.67-.36.81-.7.09-.22.11-.46.05-.7C11.56.43,10.06.01,9.22,0c-.84-.02-2.37.34-3.09,2.92-.17.62.19,1.26.81,1.43.62.17,1.26-.18,1.43-.81Z" style="stroke-width: 0px;"></path></g></g></svg>
    <span>{{ buttonData.text }}</span>
  </v-btn>
</template>
<script>
export default {
  props: ["id"],
  data() {
    return {
      tripPlanner: {
        active: {
          text: "Remove from trip plan",
          icon: "mdi-close",
          iconColour: "secondary"
        },
        inactive: {
          text: "Add to trip planner",
          icon: "mdi-plus",
          iconColour: "primary"
        }
      }
    };
  },
  methods: {
    tripPlannerToggle() {
      this.$store.commit("tripPlannerToggle", this.id);
    }
  },
  computed: {
    buttonData() {
      if (this.inTripPlanner) {
        return this.tripPlanner.active;
      }
      return this.tripPlanner.inactive;
    },
    inTripPlanner() {
      return this.$store.state.tripPlannerData.includes(this.id);
    }
  }
};
</script>

<style lang="scss">
  .add-to-trip-planner {
    font-size: 14px;
  }

  .trip-planner-icon {
    width: 18px;
    margin-right: 7px;
  }
</style>